import { render, staticRenderFns } from "./AreaInputQuestionView.vue?vue&type=template&id=2a9f8b34&scoped=true&"
import script from "./AreaInputQuestionView.vue?vue&type=script&lang=ts&"
export * from "./AreaInputQuestionView.vue?vue&type=script&lang=ts&"
import style0 from "./AreaInputQuestionView.vue?vue&type=style&index=0&id=2a9f8b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9f8b34",
  null
  
)

export default component.exports